module.exports = __webpack_public_path__ + "img/haft-poznan-07.39f441f9.jpg";